module.exports = __webpack_public_path__ + "img/banner_wrap2.30d7559d.png";